import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function SectionIntro() {
  const { t } = useTranslation('blogsignes');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <div
      ref={ref}
      id="intro"
      className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
    >
      <p className="text-slate-primary/80 text-base md:text-lg leading-relaxed mb-5">{t('intro_p1')}</p>
      <p className="text-slate-primary/80 text-base md:text-lg leading-relaxed mb-5">{t('intro_p2')}</p>
      <p className="text-slate-primary/80 text-base md:text-lg leading-relaxed font-semibold text-slate-primary">{t('intro_p3')}</p>
    </div>
  );
}